/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  GamoraFoundationAdapterQuery,
  GamoraFoundationAdapterQueryArgs,
  GamoraFoundationAdapterQueryOperator,
} from '../query.js';
import { GamoraUUIDGuard } from '../../../guards/uuid.js';

/**
 * @public
 */
export type GamoraFoundationAdapterQueryUpsertDefaultSubject = unknown;

/**
 * @public
 */
export type GamoraFoundationAdapterQueryUpsertOperand<TSubject> = [
  string,
  GamoraUUIDGuard,
  TSubject,
];

/**
 * @public
 */
export type GamoraFoundationAdapterQueryUpsertResult = boolean;

/**
 * @public
 */
export type GamoraFoundationAdapterQueryUpsertArgs<TSubject> =
  GamoraFoundationAdapterQueryArgs<
    GamoraFoundationAdapterQueryUpsertOperand<TSubject>
  >;

/**
 * @public
 */
export class GamoraFoundationAdapterQueryUpsert<
  TSubject = GamoraFoundationAdapterQueryUpsertDefaultSubject,
> extends GamoraFoundationAdapterQuery<
  GamoraFoundationAdapterQueryUpsertOperand<TSubject>,
  GamoraFoundationAdapterQueryUpsertResult
> {
  protected override _operator: GamoraFoundationAdapterQueryOperator =
    GamoraFoundationAdapterQueryOperator.UPSERT;
  constructor(args: GamoraFoundationAdapterQueryUpsertArgs<TSubject>) {
    super(args);
  }

  /**
   * Constructs query
   * @param operand The operand
   */
  static override fromOperand<
    TSubject = GamoraFoundationAdapterQueryUpsertDefaultSubject,
  >(
    operand: GamoraFoundationAdapterQueryUpsertOperand<TSubject>,
    options?: any,
  ): GamoraFoundationAdapterQueryUpsert<TSubject> {
    return new GamoraFoundationAdapterQueryUpsert({
      operand: operand,
      options,
    });
  }
}
